import { Info } from 'lucide-react';
import { mechanicTitle } from './mechanics';
import type { GlobalAnimation } from './useGlobalAnimation';

interface Props {
  /** The pack already has its own opening. */
  custom: boolean;
  global: GlobalAnimation | null;
}

/** States what the pack plays now and that saving here touches this pack only. */
export function PackOpeningNotice({ custom, global }: Props) {
  const globalName = global ? ` (${mechanicTitle(global.animation.variant)})` : '';
  return (
    <div
      role="note"
      className="flex shrink-0 items-start gap-2 border-b border-[var(--co-border)] bg-[var(--co-bg)] px-4 py-2.5 text-[12px] text-[var(--co-text)]"
    >
      <Info size={14} aria-hidden="true" className="mt-0.5 shrink-0 text-[var(--co-info)]" />
      <p>
        {custom ? (
          <>
            This pack has <strong>its own animation</strong>. Packs without their own play the
            global animation{globalName}.
          </>
        ) : global ? (
          <>
            This pack plays the <strong>global animation</strong>
            {globalName}, like every pack without its own.
          </>
        ) : (
          <>
            This pack plays the <strong>global animation</strong>, which can&apos;t be shown here.
            Pick the one this pack should play.
          </>
        )}{' '}
        Saving here changes <strong>this pack only</strong>.
      </p>
    </div>
  );
}
